import React from 'react'
import cx from 'classnames'
import { Character } from 'types/account'
import { RichTextMicroCopy } from 'pages/news/components/newsDetail/components/rich-text/RichText'
import RichTextType from 'models/types/ts/richTextType'
import { ClipLoader } from 'react-spinners'
import { getPlainTextFromRichText } from '../../../../utils'
import style from './CharacterSelect.module.scss'

interface CharacterSelectProps {
    selectedCharacterId?: number
    setSelectedCharacterId: (id?: number) => void
    characters: Character[]
    placeholder: RichTextType
    fetchingCharacters: boolean
    hasError: boolean
    errorMessage?: string
    mustHaveCharacterMessage: RichTextType
}

const CharacterSelect: React.FC<CharacterSelectProps> = ({
    selectedCharacterId,
    setSelectedCharacterId,
    characters,
    placeholder,
    fetchingCharacters,
    hasError,
    errorMessage,
    mustHaveCharacterMessage,
}) => {
    // Check if user has any characters
    const hasCharacters = characters && characters.length > 0

    if (fetchingCharacters) {
        return (
            <div className={style.characterSelectContainer}>
                <div className={style.loadingContainer}>
                    <div className={style.characterLabel}>
                        {getPlainTextFromRichText(placeholder)}
                    </div>
                    <div className={style.loading}>
                        <ClipLoader size={30} color="#F67C0F" loading />
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className={style.characterSelectContainer}>
            {hasCharacters ? (
                <>
                    <div className={style.characterLabel}>
                        {getPlainTextFromRichText(placeholder)}
                    </div>
                    <div className={style.characterSelector}>
                        {characters.map((character) => (
                            <button
                                key={character.id}
                                type="button"
                                className={cx(style.characterButton, {
                                    [style.selected]:
                                        selectedCharacterId === character.id,
                                    [style.inputError]: hasError,
                                })}
                                onClick={() =>
                                    setSelectedCharacterId(character.id)
                                }
                                title={character.name}
                            >
                                <div className={style.characterPortrait}>
                                    <img
                                        src={`https://image.eveonline.com/Character/${character.id}_512.jpg`}
                                        alt={character.name}
                                    />
                                </div>
                                <span className={style.characterName}>
                                    {character.name}
                                </span>
                            </button>
                        ))}
                    </div>
                </>
            ) : (
                <div
                    className={cx(
                        style.characterSelect,
                        style.noCharactersMessage
                    )}
                >
                    <RichTextMicroCopy document={mustHaveCharacterMessage} />
                </div>
            )}

            {hasError && errorMessage && (
                <div className={style.errorMessage}>{errorMessage}</div>
            )}
        </div>
    )
}

export default CharacterSelect
